// Runtime config the WordPress plugin passes to the widget as data-* attributes
// on the <spezzial-ai-wrap> element (see class-product-embed.php).

export type ProductImage = { id: number; url: string; alt: string };

export type WidgetConfig = {
  restColorize: string;
  restQuota: string;
  restLogin: string;
  restRegister: string;
  nonce: string;
  loginNonce: string;
  registerNonce: string;
  registrationEnabled: boolean;
  loggedIn: boolean;
  loginUrl: string;
  quotaLimit: number;
  quotaPeriod: string;
  productId: number;
  productName: string;
  productImages: ProductImage[];
  demoBefore: string;
  demoAfter: string;
  privacyUrl: string;
  privacyLabel: string;
  marketingOptinHtml: string;
};

function parseImages(raw: string | null): ProductImage[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((x): x is ProductImage => !!x && typeof x === 'object')
      .map((x) => ({
        id: Number((x as ProductImage).id) || 0,
        url: String((x as ProductImage).url ?? ''),
        alt: String((x as ProductImage).alt ?? ''),
      }))
      .filter((x) => x.id > 0 && x.url !== '');
  } catch {
    return [];
  }
}

export function readConfig(el: HTMLElement): WidgetConfig {
  const attr = (name: string): string => el.getAttribute(name) ?? '';
  return {
    restColorize: attr('data-rest-colorize'),
    restQuota: attr('data-rest-quota'),
    restLogin: attr('data-rest-login'),
    restRegister: attr('data-rest-register'),
    nonce: attr('data-nonce'),
    loginNonce: attr('data-login-nonce'),
    registerNonce: attr('data-register-nonce'),
    registrationEnabled: attr('data-registration-enabled') === '1',
    loggedIn: attr('data-logged-in') === '1',
    loginUrl: attr('data-login-url'),
    quotaLimit: Number(attr('data-quota-limit')) || 0,
    quotaPeriod: attr('data-quota-period') || 'monthly',
    productId: Number(attr('data-product-id')) || 0,
    productName: attr('data-product-name'),
    productImages: parseImages(el.getAttribute('data-product-images')),
    demoBefore: attr('data-demo-before'),
    demoAfter: attr('data-demo-after'),
    privacyUrl: attr('data-privacy-url'),
    privacyLabel: attr('data-privacy-label'),
    marketingOptinHtml: attr('data-marketing-optin-html'),
  };
}
